import { Injectable } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import { Router } from "@angular/router";
import { Observable, throwError } from "rxjs";
import { ToastMessageService } from "src/app/toastr.service";

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  constructor(private router: Router, private toastService: ToastMessageService) { }

  handleError(error: HttpErrorResponse): Observable<never> {
    if (error.status === 401) {
      console.warn("Unauthorized (401) - Redirecting to login");
      this.logout();
    } else {
      // Log detailed error message
      console.error("An error occurred:", error);

      // Optionally, handle specific HTTP status codes
      if (error.status === 500) {
        console.error("Server error occurred:", error.error?.message || error.message);
        this.toastService.error('Error: ' + (error.error.message || 'Something went wrong. Please try again.'));
      } else if (error.status === 404) {
        console.log("Resource not found:", error.error?.message || error.message);
        this.toastService.error('Error: ' + (error.error.message || 'Something went wrong. Please try again.'));
      } else if (error.status === 400) {
        console.log("Bad Request:", error.error?.message || error.message);
        this.toastService.error('Error: ' + (error.error.message || 'Something went wrong. Please try again.'));
      }
      // You can add more specific checks as needed, such as for 400, 403, etc.
    }

    // Return a custom error message
    const errorMessage = error.error?.message || error.message || "An unexpected error occurred. Please try again.";
    return throwError(() => new Error(errorMessage));
  }

  private logout(): void {
    localStorage.removeItem("access_token");
    this.router.navigate(["/login"]);
  }
}